/**
 * @generated SignedSource<<1f26a1596b8dcae89c8899ac4d8b705c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Role = "ADMIN" | "APPROVER" | "EDITOR" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type hooksUseUserRoleCheck$data = {
  readonly accountRoles: ReadonlyArray<{
    readonly role: Role;
  }>;
  readonly superuser: boolean;
  readonly userBrands: ReadonlyArray<{
    readonly brand: {
      readonly id: string;
    };
    readonly roles: ReadonlyArray<{
      readonly role: Role;
    }>;
  }>;
  readonly " $fragmentType": "hooksUseUserRoleCheck";
};
export type hooksUseUserRoleCheck$key = {
  readonly " $data"?: hooksUseUserRoleCheck$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksUseUserRoleCheck">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "role",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "hooksUseUserRoleCheck",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "superuser",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserRole",
      "kind": "LinkedField",
      "name": "accountRoles",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserBrand",
      "kind": "LinkedField",
      "name": "userBrands",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserRole",
          "kind": "LinkedField",
          "name": "roles",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Brand",
          "kind": "LinkedField",
          "name": "brand",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "74ea25ddaa1f9ddcd9e853889b97393c";

export default node;
